import { BrowserRouter as Router } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import { Home } from './pages/Home/';
import { Dashboard } from './pages/Dashboard';
import { Cargos } from './pages/Cargos';
import { Usuarios } from './pages/Usuarios';
import { Equipes } from './pages/Equipes';
import { DetalheLead } from './pages/Leads';
import { Tarefas } from "./pages/Tarefas";
import { TarefaContextProvider } from "./context/tarefa.service";

export const Rotas = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/tarefas" element={<Tarefas />} />
        <Route path="/cargos" element={<Cargos />} />
        <Route path="/usuarios" element={<Usuarios />} />
        <Route path="/equipes" element={<Equipes />} />
        <Route path="/lead/:leadId" element={<DetalheLead />} />
        <Route path="/lead/:leadId/tarefa" element={<DetalheLead />} />
      </Routes>
    </Router>
  );
}
